"use strict";

exports.__esModule = true;
exports["default"] = ProductCharging;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ProductCharging(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.78 19.786h2.2a.96.96 0 0 0 .958-.962v-5.652a.957.957 0 0 0-.958-.957h-2.2v7.571zM24.289 8.914H1.862a1.8 1.8 0 0 0-1.799 1.799v10.572c0 .999.806 1.8 1.8 1.8H24.29c.994 0 1.802-.801 1.802-1.8l-.001-10.572c0-.994-.808-1.799-1.802-1.799zm-3.677 6.068l-5.078 4.73c-.165.153-.381.229-.598.229s-.432-.076-.597-.229l-3.016-2.808-4.581 1.419a.873.873 0 0 1-.99-.332.75.75 0 0 1 .124-.971l5.077-4.729c.166-.153.382-.231.598-.231s.435.078.6.231l3.014 2.81 4.582-1.422a.843.843 0 0 1 .266-.041c.289 0 .564.136.72.374a.747.747 0 0 1-.121.97z"
  }));
}